import { format } from 'date-fns'

/////////// helper functions
export const convertISOToDate = (dateString) => {
  const parsedDateArray = dateString.split(`-`)
  return new Date(
    parsedDateArray[0],
    parsedDateArray[1] - 1,
    parsedDateArray[2],
  )
}
// works for 12/31/2022 or 12-31-2022 or 2020-12-31 formats. Please refactor if we encounter another format
window.dateStringToDate = (dateString) => {
  const dateArr = dateString.split(/[-/]/)
  if (isISO(dateString)) return new Date( dateArr[0], dateArr[1] - 1, dateArr[2])
  return new Date( dateArr[2], dateArr[0] - 1, dateArr[1])
}
////////// end of helper functions

//date fns functions
export const dateFnsFormat = function(date, formatting="MM/dd/yyyy", options) {
  return format(date, formatting, options)
}

//converts iso string format to a different date format e.g. 2022-12-31 to 12/31/2022
export const formatIsoDateString = (dateString, formatting="MM/dd/yyyy", options) => {
  const date = convertISOToDate(dateString)
  return format(date, formatting, options)
}
export const formatRegularDateString = (dateString, formatting="yyyy-MM-dd", options) => {
  const date = window.dateStringToDate(dateString)
  return format(date, formatting, options)
}

export const isISO = (dateString) => {
  const dateArr = dateString.split(/[-/]/)
  return dateArr[0].length === 4
}

export const formatDate = (date, formatting, options) => {
  if (date instanceof Date) return dateFnsFormat(date, formatting, options)
  if (isISO(date)) return formatIsoDateString(date, formatting, options)
  return formatRegularDateString(date, formatting, options)
}

export const convertMMDDYYYYToDate = (dateString) => {
  const [m, d, y] = dateString.split("/")
  return new Date(y, m - 1, d)
}
